import { useEffect } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { StreamAction } from '../stream.action';
import { IStream } from '../stream.interface';
import { streamDetailsLoaderPropsSelector } from './streamDetailsLoaderProps.selector';

export const useStreamDetailsLoader = (streamId: IStream['streamId']) => {
  const dispatch = useDispatch();

  const { isLoading, isInitialized } = useSelector(streamDetailsLoaderPropsSelector, { streamId });

  useEffect(() => {
    if (streamId && !isInitialized) {
      dispatch(StreamAction.load.started({ streamId }));
    }
  }, [dispatch, streamId, isInitialized]);

  return { isLoading, isInitialized };
};
